<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="AzObject"
                        :label="$t('lang_LABEL_TRACKS_GLOC_NAME')"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :alvqa="alvqa + '-autocomplete-azobject-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-azobject-selection'">
                                <!-- {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span> -->
                                {{ $alvPlugin.showNameOfAzEntry(item) }}
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-azobject-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-azobject-dropdown-' + items.alvId + '-title'">
                                    {{ $alvPlugin.showNameOfAzEntry(items) }}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-azobject-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <BaseEditPageTextField 
                        :context="context"
                        field="Split"
                        :label="$t('lang_LABEL_TRACK_GLOC_SPLIT')"
                        :withMargin="false"
                        rules="percentDecimal|required"
                        :alvqa="alvqa +'-textfield-split'"
                        suffix="%"
                    />
                </v-col>
                <v-col cols="5">
                    <BaseEditPageTextField 
                        :context="context"
                        field="GlocSalesType"
                        :label="$t('lang_GENERIC_CAPTION_SALES_TYPE')"
                        :withMargin="false"
                        :alvqa="alvqa +'-textfield-gloc-sales-type'"
                    />
                </v-col>
                <v-col cols="5">
                    <BaseEditPageTextField
                        :context="context"
                        field="StatementText"
                        :label="$t('lang_LABEL_TRACK_GLOC_STATEMENT_STRING')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-statement-text'"
                        />
                </v-col>
                <!-- <v-col cols="1" align-self="center">
                    <BaseTooltip>
                        <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                        <template v-slot:text><span> {{ $t('lang_GENERIC_CAPTION_ARTISTS_PRIMARY_INFO_ICON') }} </span></template>
                    </BaseTooltip>
                </v-col> -->
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextField
                        :context="context"
                        field="GlocNotes"
                        :label="$t('lang_GENERIC_CAPTION_NOTES')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-notes'"
                        />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseTooltip from '@/components/_base/BaseTooltip'

import { DropdownGeneralArtistRoles, DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TracksGlocEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageAutocomplete,
        BaseEditPageTextField,
        BaseTooltip
    },
    data() {
        return {
            context: "TracksGloc",
            alvqa: "label-tracks-edit-form-panel-gloc-editing-panel"
        }
    },
    computed: {
    }
}
</script>